import React, { useState } from "react";
import { Link } from "react-router-dom";
import {
  Coins,
  Video,
  Flame,
  BarChart3,
  Lock,
  Route,
  Info,
  HelpCircle,
  Users2,
  Menu,
  X
} from "lucide-react";

export default function Header() {
  const [isOpen, setIsOpen] = useState(false);
  const toggleMenu = () => setIsOpen(!isOpen);

  const navItems = [
    { to: "/presale", icon: Coins, label: "Presale" },
    { to: "/videos", icon: Video, label: "Videos" },
    { to: "/burning", icon: Flame, label: "Burning" },
    { to: "/staking", icon: BarChart3, label: "Staking" },
    { to: "/vesting", icon: Lock, label: "Vesting" },
    { to: "/vestingstrategic", icon: Lock, label: "Strategic" },
    { to: "/roadmap", icon: Route, label: "Roadmap" },
    { to: "/tokenomics", icon: Info, label: "Token" },
    { to: "/faq", icon: HelpCircle, label: "FAQ" },
    { to: "/community", icon: Users2, label: "Social" },
  ];

  return (
    <header className="bg-gradient-to-b from-[#4c33e3] to-[#0a061f] text-white shadow-lg">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-10 py-4 flex items-center justify-between">
        {/* Logo */}
        <Link to="/" className="flex items-center space-x-2">
          <img
            src="/assets/icons/mcn-token.png"
            alt="Medicoin"
            className="w-10 h-10 rounded-full"
          />
          <span className="text-2xl font-bold tracking-wide">MediCoin</span>
        </Link>

        {/* Desktop Menu */}
        <nav className="hidden md:flex space-x-6 text-[17px] font-medium text-gray-200">
          {navItems.map(({ to, icon: Icon, label }) => (
            <Link key={to} to={to} className="hover:text-white flex items-center space-x-1 truncate whitespace-nowrap">
              <Icon size={18} />
              <span>{label}</span>
            </Link>
          ))}
        </nav>

        {/* Mobile Menu Toggle */}
        <button onClick={toggleMenu} className="md:hidden focus:outline-none">
          {isOpen ? <X size={28} /> : <Menu size={28} />}
        </button>
      </div>

      {/* Mobile Dropdown Menu */}
      {isOpen && (
        <div className="md:hidden px-4 pb-4 space-y-3 bg-[#1a133d] text-gray-200 text-base max-h-[80vh] overflow-y-auto">
          {navItems.map(({ to, icon: Icon, label }) => (
            <Link
              key={to}
              to={to}
              onClick={toggleMenu}
              className="flex items-center space-x-2 truncate whitespace-nowrap"
            >
              <Icon size={18} />
              <span>{label}</span>
            </Link>
          ))}
        </div>
      )}
    </header>
  );
}
